if (autoplay) {
  autoScrollInit('.internetCelebrityWall .videoSlider');
  // autoStepScrollInit('.internetCelebrityWall .videoSlider');
}

touchEventInit($(".internetCelebrityWall .videoSlider"));

$('.internetCelebrityWall .videoSlider .item .itemBox .videoBox, .internetCelebrityWall .videoSlider .item .itemBox .btn').on('click', function (event) {
  event.stopPropagation();
  event.preventDefault();
  const currentItem = $(this).closest(".item");
  currentItem.find("video")[0].pause();

  internetCelebrityWallPopupOpen(sectionId, $(this).closest('.item').index() + 1);
})

$(
  ".internetCelebrityWall .videoSlider .item video"
).on("canplaythrough", function () {
  var isPlay = false;
  $(this)
    .closest(".item")
    .on("mouseover", function () {
      $(this).find("video")[0].play();
    });
  $(this)
    .closest(".item")
    .on("mouseout", function () {
      $(this).find("video")[0].pause();
    });
  $(this).on("play", function () {
    isPlay = true;
  });

  $(this).on("pause", function () {
    isPlay = false;
  });
});

$(
  ".internetCelebrityWall .videoSlider .item"
).hover(function () {
  $(this).find("video")[0].pause();
});